import LoadingSpinnerGreen from 'components/ui/LoadingSpinnerGreen'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'store'
import { selectAuth } from 'store/authentication/slice'
import { getConfiguration } from 'store/authentication/thunks'
import CourseGpsEditor from './CourseGpsEditor'
import { styled } from 'styled-components'

export default function CourseGpsEditorWrapper(): JSX.Element {
  const dispatch = useAppDispatch()
  const { siteConfig } = useSelector(selectAuth)
  const apiKey = process.env.REACT_APP_MAPS_API_KEY || siteConfig?.googleMapsApiKey

  useEffect(() => {
    dispatch(getConfiguration())
  }, [])

  if (!apiKey) {
    return (
      <SpinnerContainer>
        <LoadingSpinnerGreen size={72} />
      </SpinnerContainer>
    )
  }
  return <CourseGpsEditor apiKey={apiKey} />
}

const SpinnerContainer = styled.div`
  display: flex;
  width: 100%;
  height: 50vh;
  padding-top: 30vh;
  justify-content: center;
`
